import { render, staticRenderFns } from "./CameraUploadModal.vue?vue&type=template&id=08bed547&scoped=true&"
import script from "./CameraUploadModal.vue?vue&type=script&lang=js&"
export * from "./CameraUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./CameraUploadModal.vue?vue&type=style&index=0&id=08bed547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bed547",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VImg,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bed547')) {
      api.createRecord('08bed547', component.options)
    } else {
      api.reload('08bed547', component.options)
    }
    module.hot.accept("./CameraUploadModal.vue?vue&type=template&id=08bed547&scoped=true&", function () {
      api.rerender('08bed547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CameraUploadModal.vue"
export default component.exports